<template>
  <main-layout :selectedMenu="'activity'">
    <el-form class="activity-signUp" ref="form" :rules="rules" :model="form">
      <div class="banner"></div>
      <div class="content1">
        <div class="head">{{$t('global.填写报名信息')}}</div>
        <div class="title">{{$t('global.报名参赛须知')}}：</div>
        <div class="content">
          1. 【大师奖】【先锋奖】及【创意奖】（共26组）的完整版权将转让至主办方公司（或其指定的公司），作者需协助签署
          《著作权转让协议》。主办方享有对相应设计方案进行再设计、生产、销售、展示、出版等全部权益，作者不得将此权利再 次授权任何其他个人或机构。作者保留对其作品的永久署名权。 2.
          若主办方需对获奖作品进行进一步完善或开发、设计周边产品，获奖作者需协助配合。
        </div>
      </div>
      <div class="cooperate">
        <el-form-item prop="name">
          <div class="contain">
            <div class="left">
              <div class="font">{{$t('global.姓名')}}</div>
              <el-input
                type="text"
                class="resetW"
                :placeholder="$t('global.必填项')"
                v-model="form.name"
              ></el-input>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="age">
          <div class="contain">
            <div class="left">
              <div class="font">{{$t('global.年龄')}}</div>
              <el-input
                type="text"
                class="resetW"
                :placeholder="$t('global.必填项')"
                v-model="form.age"
              ></el-input>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="phone">
          <div class="contain">
            <div class="left">
              <div class="font">{{$t('global.手机号')}}</div>
              <el-input
                type="text"
                class="resetW"
                :placeholder="$t('global.必填项')"
                v-model="form.phone"
              ></el-input>
            </div>
          </div>
        </el-form-item>
        <div class="notify">*{{$t('global.用于通知')}}，{{$t('global.不会泄露您个人信息')}}</div>
        <div class="font occupationF">{{$t('global.职业')}}（{{$t('global.可多选')}}）</div>
        <el-form-item prop="checkedProfession">
          <el-checkbox-group v-model="form.checkedProfession">
            <el-checkbox
              v-for="(item ,index) in checkboxProfessionList"
              :key="index"
              :label="item"
              class="checkbox-padding"
            ></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <div class="submit button" @click="submit">{{$t('global.提交')}}</div>
      </div>
      <service />
    </el-form>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import service from "@/components/service.vue";

export default {
  name: "competitionSignUp",
  metaInfo() {
    return {
      title: this.$t("global.比赛报名") + " | MANA"
    };
  },
  components: {
    service,
    MainLayout
  },

  data() {
    return {
      form: {
        name: "",
        age: "",
        phone: "",
        checkedProfession: []
      },
      checkboxProfessionList: [
        $t("global.艺术"),
        $t("global.设计"),
        $t("global.科技"),
        $t("global.广告公关"),
        $t("global.新闻媒体"),
        $t("global.教育培训"),
        $t("global.金融投资"),
        $t("global.建筑业"),
        $t("global.房地产业"),
        $t("global.旅游餐饮"),
        $t("global.学生"),
        $t("global.其他")
      ],
      rules: {
        name: [
          {
            required: true,
            message: $t("global.姓名不能为空"),
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: $t("global.手机号不能为空"),
            trigger: "blur"
          },
          {
            pattern: /^1[0-9]{10}$/,
            message: $t("global.请输入正确的手机号"),
            trigger: "blur"
          }
        ],
        age: [
          {
            pattern: /^[0-9]{0,3}$/,
            message: $t("global.请输入正确的年龄"),
            trigger: "blur"
          }
        ],
        checkedProfession: [
          {
            required: true,
            message: $t("global.请选择职业"),
            trigger: "change"
          }
        ]
      }
    };
  },

  methods: {
    submit: function() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.$http
            .post("/api/u/sign/apply/info", {
              activityId: this.$route.params.id,
              name: this.form.name,
              age: this.form.age,
              phone: this.form.phone,
              career: this.form.checkedProfession.join(",")
            })
            .then(res => {
              if (res) {
                this.$message({
                  message: res.message,
                  type: "success",
                  dureation: 2000
                });
                this.$router.go(-1);
                this.form = {};
              }
            });
        }
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.checkbox-padding {
  display: inline-box;
  padding-top: 0.2rem;
}

.occupationF {
  margin: 0.62rem 0 0.3rem 0;
}

.font {
  color: #000000;
  font-size: 0.2rem;
}

.submit {
  margin: 0.4rem auto;
}

.up-load-wrap {
  margin-top: 0.4rem;
}

.button {
  cursor: pointer;
  width: 2.4rem;
  height: 0.64rem;
  line-height: 0.6rem;
  text-align: center;
  font-size: 0.2rem;
  color: #FFFFFF;
  background: rgba(1, 97, 255, 1);
  border-radius: 0.08rem;
}

.contain {
  display: flex;
  justify-content: space-between;
  margin-top: 0.56rem;

  .resetW {
    width: 10rem;
  }
}

.cooperate {
  width: 10.4rem;
  /* height 7rem */
  background-color: #ffffff;
  padding: 0.6rem 2.8rem;
  margin: 0.2rem auto 0;
  text-align: left;

  .notify {
    color: #ff0000;
    font-size: 0.12rem;
    margin-top: 0.1rem;
  }
}

.banner {
  width: 100%;
  height: 6rem;
  background: url('/static/activity/signBanner.png') no-repeat;
  background-size: 100%;
}

.content1 {
  width: 10rem;
  margin: 0.4rem auto 0;
  padding: 0.6rem 3rem;
  background-color: #ffffff;

  .content {
    margin-top: 0.2rem;
    color: #707070;
    font-size: 0.16rem;
    line-height: 0.36rem;
  }

  .tilte {
    font-size: 0.2rem;
    color: #000000;
    margin-top: 0.5rem;
  }

  .head {
    font-weight: bold;
    text-align: center;
    font-size: 0.26rem;
    color: #333333;
  }
}
</style>
<style lang="stylus">
.activity-signUp {
  .el-input input, select {
    width: 6rem;
    height: 0.5rem;
    margin-top: 0.1rem;
    background-color: #F9F9F9;
    border-radius: 0.08rem;
    text-indent: 0.1rem;
    outline: none;
    border: none;
  }

  .el-checkbox {
    margin-left: 0;
    width: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/SignUp.vue